import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img className="w-25" src="https://img.freepik.com/free-vector/oops-404-error-with-broken-robot-concept-illustration_114360-5529.jpg?size=338&ext=jpg" alt="" />
        </div>
    );
};

export default NotFound;